import React from 'react';
import { Image } from 'react-bootstrap';
import Button from '../Shared/Button';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../../css/Shared/SubmitModal.css';
import success from '../../Assets/ProfileManagement/images/success.svg';
import RespModal from '../Shared/RespModal';

function SubmitModal(props) {
    return(
        <RespModal hasOpen={props.hasOpen}  >
        <div className="modalsize" >
            <Image src={success} /><br /><br />
            <div id="modalcontain">
            <p class="submitresplogintext1">Your profile has been submitted successfully for approval.</p>
            </div>
            <Button
                id="resploginbutton"
                type="button"
                class="btn btn-dark"
                onClick={props.onCloseModal}
            >OK
        </Button><br /><br />
        </div>
    </RespModal>
    );
}
export default SubmitModal;